/**
 * Given a git tree path, return the file extension or null if there is none.
 *
 * Note: `extname()` in utils.js doesn't support dotfiles.
 */
export function fileExtension(path: string): string {
  const lastPart = path.split('/').at(-1);

  const lastDotIndex = lastPart.lastIndexOf('.');
  if (lastDotIndex <= 0) {
    // the dot is either the first character (0) or not present (-1)
    // either way, that means no extension
    return '';
  }

  return lastPart.substring(lastDotIndex + 1);
}
